import { BTooltip } from './tooltip';
import { VBTooltip } from '../../directives/tooltip/tooltip';
import { pluginFactory } from '../../utils/plugins';
var TooltipPlugin =
/*#__PURE__*/
pluginFactory({
  components: {
    BTooltip: BTooltip
  },
  directives: {
    VBTooltip: VBTooltip
  }
});
export { TooltipPlugin, BTooltip };
export default TooltipPlugin;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/tooltip/index.js
// module id = GVLL
// module chunks = 21